import script from "./AlertPageV2.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertPageV2.vue?vue&type=script&setup=true&lang=js"

import "./AlertPageV2.vue?vue&type=style&index=0&id=5fcab52e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fcab52e"]])

export default __exports__